export default __webpack_public_path__ + "static/digital-9d95284245b84d383cdd330610b68d56.jpeg";